
import moment from 'moment'

export default {
  model: {
    prop: 'modelValue',
    event: 'updateModel',
  },
  props: {
    modelValue: {
      type: [String, Date, Object],
      default: new Date(),
    },
    minDate: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss',
    },
  },
  data() {
    return {
      showPopup: false,
      date: '',
      maxDate: new Date(),
    }
  },
  computed: {
    currentDate: {
      get() {
        return this.modelValue
      },
      set(v) {
        this.$emit('updateModel', moment(v).format(this.format))
      },
    },
    minLimitDate() {
      return typeof this.minDate === 'string'
        ? new Date(this.minDate)
        : this.minDate
    },
    dateView() {
      return moment(this.currentDate).format('YYYY/MM/DD')
    },
  },
  watch: {
    modelValue: {
      handler() {
        this.date = new Date(this.modelValue)
      },
      immediate: true,
    },
  },
  methods: {
    changePopup() {
      this.showPopup = !this.showPopup
    },
    cancel() {
      this.changePopup()
    },
    confirm() {
      this.changePopup()
      this.currentDate = this.date
    },
  },
}
